// components/CustomDrawer/index.jsx
import { useEffect } from 'react';
import styles from './index.module.css';

export const CustomDrawer = ({
  visible,
  title = '喂养食物',
  items,
  onConfirm,
  onClose
}) => {
  // 阻止滚动穿透
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.mask} onClick={onClose} />
      
      <div className={styles.drawer}>
        {/* 头部 */}
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
        </div>

        {/* 内容区域 */}
        <div className={styles.content}>
          {items.map(item => (
            <div key={item.id} className={styles.item}>
              <div className={styles.itemLeft}>
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className={styles.itemImage}
                />
                <div>
                  <div className={styles.itemName}>{item.name}</div>
                  <div className={styles.itemStock}>库存: {item.max}</div>
                </div>
              </div>
              
              <div className={styles.controls}>
                <button
                  className={styles.controlButton}
                  onClick={() => item.onDecrease(item.id)}
                  disabled={item.num <= 0}
                >
                  -
                </button>
                <span className={styles.count}>{item.num}</span>
                <button
                  className={styles.controlButton}
                  onClick={() => item.onIncrease(item.id)}
                  disabled={item.num >= item.max}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* 底部操作栏 */}
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            取消
          </button>
          <button className={styles.confirmButton} onClick={onConfirm}>
            确认
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomDrawer;